const SCORE_THRESHOLDS = [
  { level: 'low', to: 40 },
  { level: 'medium', from: 40, to: 65 },
  { level: 'high', from: 65 }
];

export const getScoreLevel = (score: number) => {
  for (let i = 0; i < SCORE_THRESHOLDS.length; i += 1) {
    const from = SCORE_THRESHOLDS[i].from || 0;
    const to = SCORE_THRESHOLDS[i].to || Number.MAX_SAFE_INTEGER;
    if (score >= from && score < to) {
      return SCORE_THRESHOLDS[i].level;
    }
  }

  return '';
};
